import { FC } from 'react'
import { Link } from 'react-router-dom'
import { Card } from 'react-bootstrap'
import clsx from 'clsx'

import styles from './HighlightCard.module.scss'

interface HighlightCardProps {
    title: string
    image: string
    link: string,
    created_at: string,
    category: string,
    className?: string
    loading?: boolean
    height?: string
}

const HighlightCard: FC<HighlightCardProps> = ({
    title,
    image,
    link,
    created_at,
    category,
    className,
    loading,
    height
}) => {
    return (
        <Link to={link} className='text-decoration-none'>
            <Card className={clsx('border-0 shadow-sm rounded-4 overflow-hidden h-100', styles.blogHighlightCard)}>
                <div className='position-relative h-100'>
                    <Card.Img 
                        src={image} 
                        alt={title}
                        className={clsx('w-100', styles.blogHighlightCardImage)}
                        style={{ minHeight: height, maxHeight: height }}
                    />
                    {/* Dark overlay */}
                    <div 
                        className='position-absolute top-0 start-0 w-100 h-100' 
                        style={{ 
                            background: 'rgba(0, 0, 0, 0.2)',
                            zIndex: 1
                        }}
                    ></div>
                                
                    {/* Content overlay using Card.Body */}
                    <Card.Body className='position-absolute top-0 start-0 w-100 h-100 text-white d-flex flex-column justify-content-between' style={{ zIndex: 2, background: 'transparent' }}>
                        {/* Date tag at top */}
                        <div className='d-flex flex-column justify-content-center bg-primary text-white p-2 rounded-2' style={{ width: '56px', height: '56px' }}>
                            <div className='fw-bold fs-1 m-0 text-center' style={{ lineHeight: '1' }}> 
                                {created_at && new Date(created_at).getDate() || '-'}
                            </div>
                            <div className='fw-normal fs-5 m-0 text-center'>
                                {created_at && new Date(created_at).toLocaleDateString('en-US', { month: 'short' }) || '-'}
                            </div>
                        </div>
                        
                        {/* Content at bottom */}
                        <div>
                            <div className='d-flex align-items-center gap-2 mb-2'>
                                <i className='bi bi-tag text-primary'></i>
                                <span className='small'>{category}</span>
                            </div>
                            <h3 className='fw-bold mb-0'>
                                {title}
                            </h3>
                        </div>
                    </Card.Body>
                </div>
            </Card>
        </Link>
    )
}

export default HighlightCard